import React from 'react';
import { Routes,Route } from 'react-router-dom';
import IndexOne from './index/index-one';
import TerminosCondiciones from './Pages/TerminosCondiciones';
import PrivacyPolicy from './Pages/PoliticasPrivacidad';



function App() {
  return (
    <>
    <Routes>
      <Route path='/' element={<IndexOne/>}/>
      <Route path="/info/d" element={<IndexOne/>} />
      <Route path='/terminos-condiciones' element={<TerminosCondiciones/>}/>
      <Route path='/politicas-privacidad' element={<PrivacyPolicy/>}/>

    </Routes>
    </>
  );
}

export default App;
